import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import styled from 'styled-components';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { useFlowPreviousStatesForAcq129 } from '../experiments/acq129/acq129Hooks';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from '../signup-data/DATA';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import PrivacyBanner from '../views-components/PrivacyBanner';
import { Step } from '../views/Step';
import { getLandingPageButton } from './getLandingPageText';
import { HaveAnAccountLink } from './HaveAnAccountLink';
import { renderLandingPageTitle } from './renderLandingPageTitle';
import { useLandingPage } from './useLandingPage';
const EmbeddedHaveAnAccount = styled.div.withConfig({
  displayName: "LandingPageView__EmbeddedHaveAnAccount",
  componentId: "sc-176kln1-0"
})(["", ""], props => props.theme.embedded && `
      margin-top: 1.5rem;
      font-size: 14px;
      margin-bottom: 1.5rem;
    `);

const LandingPageView = () => {
  const stepKey = Step.LandingPage;
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    isMobile
  } = useResponsiveness();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  useExperiment(ExperimentKeys.ACQ129, TrackWhen.assignedToControl);
  useExperiment(ExperimentKeys.ACQ130, TrackWhen.enrolled);
  useExperiment(ExperimentKeys.ACQ128, TrackWhen.enrolled);
  useFlowPreviousStatesForAcq129();

  const renderUserInfo = () => /*#__PURE__*/_jsx(SignupDataInputForm, {
    autoFocus: false,
    buttonProps: {
      label: getLandingPageButton()
    },
    dataKey: Data.Email,
    inputMode: 'email',
    submit: chooseEmailSignUp
  }, Data.Email);

  const renderContent = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OAuthSignupSection, {}), renderUserInfo()]
  });

  const renderFooter = () => {
    return isInstanceOfSignupEmbedder ? /*#__PURE__*/_jsxs(EmbeddedHaveAnAccount, {
      className: "text-center",
      children: [/*#__PURE__*/_jsx(HaveAnAccountLink, {}), /*#__PURE__*/_jsx(PrivacyBanner, {})]
    }) : /*#__PURE__*/_jsx(PrivacyBanner, {});
  };

  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.LandingPage,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: [renderLandingPageTitle({
          isMobile
        }), renderContent(), renderFooter()]
      })
    })
  });
};

export default LandingPageView;